// Custom JS
$( document ).ready(function() {
    
    // Fix for rk-bestsellers widget cart integration
    function initRKWidgetCartFix() {
        console.log('Initializing RK Widget Cart Fix...');
        
        // Multiple approaches to catch the widget
        var attempts = 0;
        var maxAttempts = 40; // 20 seconds total
        
        var checkInterval = setInterval(function() {
            attempts++;
            var rkWidget = document.getElementById('rk-widget-221044');
            var customReccomWidget = document.querySelector('.rk-bestsellers.custom-reccom');
            
            console.log('Attempt', attempts, '- RK Widget found:', !!rkWidget, '- Custom reccom found:', !!customReccomWidget);
            
            if ((rkWidget || customReccomWidget) && attempts > 3) { // Wait a bit for content to load
                clearInterval(checkInterval);
                setupRKCartIntegration();
            } else if (attempts >= maxAttempts) {
                clearInterval(checkInterval);
                console.log('RK Widget not found after', maxAttempts, 'attempts');
            }
        }, 500);
    }
    
    function setupRKCartIntegration() {
        console.log('Setting up RK Cart Integration...');
        
        // Target both possible widget containers
        var widgets = [
            document.getElementById('rk-widget-221044'),
            document.querySelector('.rk-bestsellers.custom-reccom'),
            document.querySelector('.rk-bestsellers')
        ].filter(Boolean);
        
        console.log('Found widgets:', widgets.length);
        
        // Set up global click handler for the entire document
        // This catches clicks even on dynamically loaded content
        document.addEventListener('click', function(e) {
            var target = e.target;
            
            // Check if click is within any RK widget
            var isInWidget = widgets.some(function(widget) {
                return widget.contains(target);
            });
            
            if (!isInWidget) return;
            
            console.log('Click detected in RK widget:', target);
            
            // Check if it's an add to cart button - specifically target RK theme buttons
            var isAddToCartBtn = (
                target.classList.contains('rktheme-addtocart-button') ||
                target.closest('.rktheme-addtocart-button') ||
                target.closest('.rktheme-addtocart-container') ||
                target.getAttribute('data-rk-variant-id') ||
                target.closest('[data-rk-variant-id]') ||
                (target.tagName === 'BUTTON' && target.textContent.toLowerCase().includes('add to cart'))
            );
            
            if (isAddToCartBtn) {
                console.log('Add to cart button clicked:', target);
                e.preventDefault();
                e.stopPropagation();
                
                // Find the actual button element with RK variant data
                var button = target.classList.contains('rktheme-addtocart-button') ? target :
                           target.closest('.rktheme-addtocart-button') ||
                           target.closest('[data-rk-variant-id]') ||
                           target;
                
                handleRKAddToCart(button, target);
            }
        }, true); // Use capture phase
        
        // Also use MutationObserver as backup
        widgets.forEach(function(widget) {
            if (widget) {
                var observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        mutation.addedNodes.forEach(function(node) {
                            if (node.nodeType === 1) {
                                console.log('New node added to RK widget:', node);
                            }
                        });
                    });
                });
                
                observer.observe(widget, {
                    childList: true,
                    subtree: true
                });
            }
        });
    }
    
    function handleRKAddToCart(button, target) {
        console.log('Handling RK add to cart for button:', button);
        
        // Show loading state
        var originalText = button.textContent || button.innerHTML;
        button.textContent = 'Adding...';
        button.disabled = true;
        
        // Try to find product information
        var productInfo = findProductInfo(button, target);
        
        if (productInfo.variantId) {
            console.log('Found variant ID:', productInfo.variantId);
            addToCartDirectly(productInfo.variantId, button, originalText);
        } else if (productInfo.productHandle) {
            console.log('Found product handle:', productInfo.productHandle);
            addToCartByHandle(productInfo.productHandle, button, originalText);
        } else {
            console.log('No product info found, trying to extract from context');
            // Last resort - try to find any product data in the page
            var currentUrl = window.location.pathname;
            var productHandle = currentUrl.match(/\/products\/([^\/\?#]+)/);
            
            if (productHandle) {
                console.log('Using current page product:', productHandle[1]);
                addToCartByHandle(productHandle[1], button, originalText);
            } else {
                showError(button, 'Product not found', originalText);
            }
        }
    }
    
    function findProductInfo(button, target) {
        var info = { variantId: null, productHandle: null };
        
        // First check for RK theme specific data attribute
        info.variantId = button.getAttribute('data-rk-variant-id') ||
                        target.getAttribute('data-rk-variant-id') ||
                        (button.closest('[data-rk-variant-id]') && button.closest('[data-rk-variant-id]').getAttribute('data-rk-variant-id'));
        
        // If RK variant ID found, return it
        if (info.variantId) {
            console.log('Found RK variant ID:', info.variantId);
            return info;
        }
        
        // Fallback to other data attributes
        var container = button.closest('[data-variant-id], [data-product-id], [data-product-handle]') ||
                       target.closest('[data-variant-id], [data-product-id], [data-product-handle]');
        
        if (container) {
            info.variantId = container.getAttribute('data-variant-id') || 
                           container.getAttribute('data-product-id');
            info.productHandle = container.getAttribute('data-product-handle');
        }
        
        // Check for product links nearby
        if (!info.variantId && !info.productHandle) {
            var productLink = button.closest('a[href*="/products/"]') ||
                             button.parentElement.querySelector('a[href*="/products/"]') ||
                             target.closest('a[href*="/products/"]') ||
                             target.parentElement.querySelector('a[href*="/products/"]');
            
            if (productLink) {
                var match = productLink.href.match(/\/products\/([^\/\?#]+)/);
                if (match) {
                    info.productHandle = match[1];
                }
            }
        }
        
        // Check onclick attributes for product data
        if (!info.variantId && !info.productHandle) {
            var onclickEl = button.closest('[onclick]') || target.closest('[onclick]');
            if (onclickEl) {
                var onclick = onclickEl.getAttribute('onclick');
                var variantMatch = onclick.match(/variant[_-]?id['":\s]*(\d+)/i);
                var productMatch = onclick.match(/product[_-]?id['":\s]*(\d+)/i);
                
                if (variantMatch) {
                    info.variantId = variantMatch[1];
                } else if (productMatch) {
                    info.variantId = productMatch[1];
                }
            }
        }
        
        console.log('Found product info:', info);
        return info;
    }
    
    function setupCartButton(button) {
        // Skip if already processed
        if (button.hasAttribute('data-cart-processed')) {
            return;
        }
        
        button.setAttribute('data-cart-processed', 'true');
        
        // Find product data from the button's context
        var productContainer = button.closest('[data-product-id], [data-variant-id]') || 
                              button.closest('.product-item, .product-card, .rk-product');
        
        if (!productContainer) {
            // Try to find product data in nearby elements
            var productLink = button.closest('a[href*="/products/"]') || 
                             button.parentElement.querySelector('a[href*="/products/"]');
            
            if (productLink) {
                var productHandle = extractProductHandle(productLink.href);
                if (productHandle) {
                    setupButtonWithHandle(button, productHandle);
                }
            }
        } else {
            var variantId = productContainer.getAttribute('data-variant-id') || 
                           productContainer.getAttribute('data-product-id');
            
            if (variantId) {
                setupButtonWithVariant(button, variantId);
            }
        }
    }
    
    function extractProductHandle(url) {
        var match = url.match(/\/products\/([^\/\?#]+)/);
        return match ? match[1] : null;
    }
    
    function addToCartDirectly(variantId, button, originalText) {
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        })
        .then(response => response.json())
        .then(data => {
            console.log('Successfully added to cart:', data);
            handleCartSuccess(button, originalText);
        })
        .catch(error => {
            console.error('Error adding to cart:', error);
            showError(button, 'Error adding to cart', originalText);
        });
    }
    
    function addToCartByHandle(productHandle, button, originalText) {
        fetch('/products/' + productHandle + '.js')
            .then(response => response.json())
            .then(product => {
                var availableVariant = product.variants.find(v => v.available);
                if (availableVariant) {
                    addToCartDirectly(availableVariant.id, button, originalText);
                } else {
                    showError(button, 'Product is sold out', originalText);
                }
            })
            .catch(error => {
                console.error('Error fetching product:', error);
                showError(button, 'Error loading product', originalText);
            });
    }
    
    function handleCartSuccess(button, originalText) {
        button.textContent = 'Added to cart!';
        
        // Update cart count and refresh cart
        if (window.theme && window.theme.cart) {
            window.theme.cart.getCart().then(function(cart) {
                // Update cart count in header
                var countEls = document.querySelectorAll('.cart-link__bubble-num');
                countEls.forEach(function(el) {
                    el.textContent = cart.item_count;
                });
                
                // Show cart bubble
                var bubbles = document.querySelectorAll('.cart-link__bubble');
                bubbles.forEach(function(bubble) {
                    if (cart.item_count > 0) {
                        bubble.classList.add('cart-link__bubble--visible');
                    }
                });
                
                // Trigger cart update event
                document.dispatchEvent(new CustomEvent('cart:updated', {
                    detail: { cart: cart }
                }));
                
                // Build/refresh cart drawer content
                document.dispatchEvent(new CustomEvent('cart:build'));
            });
        }
        
        // Open cart drawer
        setTimeout(function() {
            if (window.theme && window.theme.CartDrawer) {
                try {
                    var cartDrawer = new window.theme.CartDrawer();
                    cartDrawer.open();
                } catch(e) {
                    console.log('CartDrawer constructor failed, trying alternative');
                    openCartDrawerAlternative();
                }
            } else {
                openCartDrawerAlternative();
            }
        }, 300);
        
        // Reset button after delay
        setTimeout(function() {
            button.textContent = originalText;
            button.disabled = false;
        }, 2000);
    }
    
    function openCartDrawerAlternative() {
        // Try multiple methods to open cart drawer
        var cartDrawerBtn = document.querySelector('.js-drawer-open-cart') ||
                           document.querySelector('[data-drawer-open="cart"]') ||
                           document.querySelector('.cart-link');
        
        if (cartDrawerBtn) {
            cartDrawerBtn.click();
        } else {
            // If no drawer, redirect to cart page
            window.location.href = '/cart';
        }
    }
    
    function showError(button, message, originalText) {
        button.textContent = message;
        button.style.backgroundColor = '#ff4444';
        button.style.color = 'white';
        
        setTimeout(function() {
            button.textContent = originalText;
            button.style.backgroundColor = '';
            button.style.color = '';
            button.disabled = false;
        }, 3000);
    }
    
    function setupButtonWithHandle(button, productHandle) {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Fetch product data to get the first available variant
            fetch('/products/' + productHandle + '.js')
                .then(response => response.json())
                .then(product => {
                    var availableVariant = product.variants.find(v => v.available);
                    if (availableVariant) {
                        addToCart(availableVariant.id, button);
                    } else {
                        showError(button, 'Product is sold out');
                    }
                })
                .catch(error => {
                    console.error('Error fetching product:', error);
                    showError(button, 'Error adding to cart');
                });
        });
    }
    
    function setupButtonWithVariant(button, variantId) {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            addToCart(variantId, button);
        });
    }
    
    function addToCart(variantId, button) {
        // Show loading state
        var originalText = button.textContent;
        button.textContent = 'Adding...';
        button.disabled = true;
        
        // Add to cart via Shopify's AJAX API
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        })
        .then(response => response.json())
        .then(data => {
            // Success - show feedback and open cart drawer
            button.textContent = 'Added to cart!';
            
            // Update cart count and refresh cart
            if (window.theme && window.theme.cart) {
                window.theme.cart.getCart().then(function(cart) {
                    // Update cart count in header
                    var countEls = document.querySelectorAll('.cart-link__bubble-num');
                    countEls.forEach(function(el) {
                        el.textContent = cart.item_count;
                    });
                    
                    // Show cart bubble
                    var bubbles = document.querySelectorAll('.cart-link__bubble');
                    bubbles.forEach(function(bubble) {
                        if (cart.item_count > 0) {
                            bubble.classList.add('cart-link__bubble--visible');
                        }
                    });
                    
                    // Trigger cart update event
                    document.dispatchEvent(new CustomEvent('cart:updated', {
                        detail: { cart: cart }
                    }));
                    
                    // Build/refresh cart drawer content
                    document.dispatchEvent(new CustomEvent('cart:build'));
                });
            }
            
            // Open cart drawer if it exists
            setTimeout(function() {
                if (window.theme && window.theme.CartDrawer) {
                    var cartDrawer = new window.theme.CartDrawer();
                    cartDrawer.open();
                } else {
                    // Fallback: try to trigger cart drawer open button
                    var cartDrawerBtn = document.querySelector('.js-drawer-open-cart');
                    if (cartDrawerBtn) {
                        cartDrawerBtn.click();
                    }
                }
            }, 300);
            
            // Reset button after delay
            setTimeout(function() {
                button.textContent = originalText;
                button.disabled = false;
            }, 2000);
        })
        .catch(error => {
            console.error('Error adding to cart:', error);
            showError(button, 'Error adding to cart');
            
            // Reset button
            setTimeout(function() {
                button.textContent = originalText;
                button.disabled = false;
            }, 2000);
        });
    }
    
    function showError(button, message) {
        var originalText = button.textContent;
        button.textContent = message;
        button.style.backgroundColor = '#ff4444';
        
        setTimeout(function() {
            button.textContent = originalText;
            button.style.backgroundColor = '';
            button.disabled = false;
        }, 3000);
    }
    
    // Initialize the RK widget cart fix
    initRKWidgetCartFix();
    
    // Also try to setup on page load and theme events
    document.addEventListener('page:loaded', initRKWidgetCartFix);
    document.addEventListener('shopify:section:load', initRKWidgetCartFix);
    jQuery('.ContactFormGifitingCategory').change(function(e) {
        var gifitingcategory = $(this,':selected').val();
        if(gifitingcategory == "Others"){
        	$('.others-field').show();
        }else{
          	$('.others-field').hide();
        }
    });
    jQuery('.ContactFormOccasion').change(function(e) {
          var occasion = $(this,':selected').val();
          if(occasion == "Others"){
              $('.others-field').show();
          }else{
              $('.others-field').hide();
          }
      });
  	jQuery(".estimated-date-of-delivery").datepicker( {
        minDate: +1,
        maxDate: '+6M',
        beforeShowDay: jQuery.datepicker.noWeekends,
      	dateFormat: "dd/mm/yy"
      });
  	jQuery('.c-slider').slick({
      infinite: true,
      speed: 300,
      slidesToShow: 2,
      dots: true,
      arrows: false,
       responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow:2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
  ]
    });
  jQuery('.carousel-slider').slick({
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
       responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow:1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
  ]
    });
   jQuery('.logo-carousel').slick({
      infinite: true,
      speed: 1000,
      slidesToShow: 5,
      slidesToScroll: 3,
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
       responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow:3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    }
  ]
    });
});


// Training Tabs Mega Menu - Hover interaction
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var navItems = document.querySelectorAll('[data-training-tab]');
    var panels = document.querySelectorAll('[data-training-panel]');

    if (!navItems.length || !panels.length) return;

    navItems.forEach(function(item) {
      item.addEventListener('mouseenter', function() {
        var tabId = this.getAttribute('data-training-tab');

        // Update active nav item
        navItems.forEach(function(nav) {
          nav.classList.remove('is-active');
        });
        this.classList.add('is-active');

        // Update active panel
        panels.forEach(function(panel) {
          panel.classList.remove('is-active');
        });
        var targetPanel = document.querySelector('[data-training-panel="' + tabId + '"]');
        if (targetPanel) {
          targetPanel.classList.add('is-active');
        }
      });
    });
  });
})();
